// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal__29a8n","backdrop":"backdrop__mZGV1"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/Modal/styles.scss
// module id = ./app/scripts/views/App/components/Modal/styles.scss
// module chunks = 1